import { Button } from '@/components/form/Button';
import { useCompletePartnerContract } from '@/services/api/hooks/partners';
import { usePartnerId } from '@/services/authentication/hooks/user';
import { motion } from 'framer-motion';
import { FC, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DecorativeSplit } from '../../../layouts/DecorativeSplit';
import { Account } from '../../../layouts/header/Account';
import { PageTitle } from '../../../utils/Title';
import { SigningEvents } from '../commonSteps/signingEvents';
import { CONTRACT_UPDATED_STATUS } from '../consts';

export const PartnerOnboardingContractSigned: FC = () => {
  const [queryParameters] = useSearchParams();
  const event = queryParameters.get('event');

  const success = event !== SigningEvents.DECLINED;

  const partnerId = usePartnerId();

  if (!partnerId) {
    throw Error('Partner ID must be provided');
  }

  const completeContract = useCompletePartnerContract(partnerId);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading(true);
    const result = await completeContract.mutateAsync({});

    if (result.status.toLowerCase().includes(CONTRACT_UPDATED_STATUS)) {
      navigate('/');
    } else {
      setLoading(false);
    }
  };

  const errorObj = completeContract.error as Error | undefined;
  const error = errorObj ? errorObj.message : '';

  return (
    <>
      <PageTitle>Partner Onboarding</PageTitle>
      <DecorativeSplit className="my-12">
        <div className="border-secondary-std flex justify-end border-b py-4">
          <motion.div layoutId="account">
            <Account />
          </motion.div>
        </div>
        <div className="mt-8">
          {!success ? (
            <div>An issue occured while signing the contract. Please contact DaaS to resolve this issue.</div>
          ) : (
            <div className="space-y-5">
              <div className="text-lg">All done - Thank you!</div>
              <div>Click Finish to begin using DaaS Portal.</div>
              {error && <p className="text-red-500 mt-2">{error}</p>}
              <Button loading={loading} onClick={onClick}>
                Finish
              </Button>
            </div>
          )}
        </div>
      </DecorativeSplit>
    </>
  );
};
